export default __webpack_public_path__ + "static/media/facebook-logo.6ae9bf0a.svg";